export enum AccessibilityToResponse {
  Default = 1,
  SubjectAndRecipient = 2,
  Recipient = 3,
}
